import React from "react";
import { cloneElement } from "react";
import {
  ArrayField,
  Show,
  ShowButton,
  SimpleShowLayout,
  ChipField,
  DateField,
  List,
  Edit,
  Create,
  Datagrid,
  TextField,
  EditButton,
  SelectInput,
  SearchInput,
  NumberField,
  SingleFieldList,
  DateInput,
  SelectArrayInput,
  SimpleForm,
  TextInput,
  Filter,
  ImageInput,
  ImageField,
  required,
  BooleanField,
  BooleanInput,
  NumberInput,
} from "react-admin";

const ProductTitle = ({ record }) => {
  return (
    <span>Product: {record ? `${record.name} ${record.volume}` : ""}</span>
  );
};

// Helper function for ArrayField (colors)
export const StringToLabelObject = ({ record, children, ...rest }) =>
  cloneElement(children, {
    record: { label: record },
    ...rest,
  });

// Search Function
const ProductFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
  </Filter>
);

export const ProductList = (props) => (
  <List
    {...props}
    filters={<ProductFilter />}
    sort={{ field: "name", order: "DESC" }}
    perPage={25}
  >
    <Datagrid>
      <EditButton />
      <ShowButton />
      <ImageField source="image" sortable={false} />
      <TextField source="id" sortable={false} />
      <TextField source="name" />
      <TextField source="sector" />
      <TextField source="cosmeticsSector" />
      <TextField source="cosmeticsType" />
      <TextField source="type" />
      {/* <TextField source="shape" /> */}
      <TextField source="material" />
      <TextField source="volume" />
      {/* <TextField source="weight" />
            <ArrayField source="colors" sortable={false}>
                <SingleFieldList>
                    <StringToLabelObject>
                        <ChipField source="label"/>
                    </StringToLabelObject>
                </SingleFieldList>
            </ArrayField> */}
      <ArrayField source="neckFinish">
        <SingleFieldList>
          <StringToLabelObject>
            <ChipField source="label" />
          </StringToLabelObject>
        </SingleFieldList>
      </ArrayField>
      {/* <TextField source="innerNeckDiameter" />
            <TextField source="outerNeckDiameter" />
            <TextField source="diameter" />
            <TextField source="height" />
            <TextField source="palletHAmount" />
            <TextField source="palletLAmount" /> */}
      <DateField source="date" />
      <BooleanField source="isActive" />
    </Datagrid>
  </List>
);

export const ProductEdit = (props) => (
  <Edit title={<ProductTitle />} {...props}>
    <SimpleForm>
      <ImageInput source="image">
        <ImageField source="src" />
      </ImageInput>
      <TextInput disabled source="id" />
      <TextInput source="name" inputProps={{ maxLength: 100 }} />
      <TextInput source="nameTR" inputProps={{ maxLength: 100 }} />
      <TextInput source="description" inputProps={{ maxLength: 1500 }} />
      <TextInput source="descriptionTR" inputProps={{ maxLength: 1500 }} />
      <SelectInput
        source="sector"
        choices={[
          { id: "oliveOil", name: "oliveOil" },
          { id: "wine", name: "wine" },
          { id: "sparkling", name: "sparkling" },
          { id: "alcohol", name: "alcohol" },
          { id: "various", name: "various" },
          { id: "cosmetics", name: "cosmetics" },
        ]}
      />
      <SelectInput
        source="cosmeticsSector"
        choices={[
          { id: "colorCosmetics", name: "colorCosmetics" },
          { id: "personalCare", name: "personalCare" },
          { id: "perfumery", name: "perfumery" },
          { id: "airRefreshener", name: "airRefreshener" },
        ]}
      />
      <SelectInput
        source="cosmeticsType"
        choices={[
          { id: "mascara", name: "mascara" },
          { id: "eyebrowMascara", name: "eyebrowMascara" },
          { id: "lipGloss", name: "lipGloss" },
          { id: "compactsPallets", name: "compactsPallets" },
          { id: "eyeliner", name: "eyeliner" },
          { id: "lipstick", name: "lipstick" },
          { id: "lipBalm", name: "lipBalm" },
          { id: "faceStick", name: "faceStick" },
          { id: "nailPolish", name: "nailPolish" },
        ]}
      />

      <SelectInput
        source="type"
        choices={[
          { id: "bottle", name: "bottle" },
          { id: "jar", name: "jar" },
          { id: "cap", name: "cap" },
          { id: "capsule", name: "capsule" },
          { id: "machine", name: "machine" },
          { id: "outer", name: "outer" },

          { id: "brush", name: "brush" },
          { id: "applicator", name: "applicator" },
          { id: "dropper", name: "dropper" },
          { id: "tube", name: "tube" },
          { id: "deoStick", name: "deoStick" },
          { id: "deoRollOn", name: "deoRollOn" },
          { id: "pump", name: "pump" },
          { id: "airlessPackaging", name: "airlessPackaging" },
          { id: "mistSprayer", name: "mistSprayer" },
          { id: "sticks", name: "sticks" },
        ]}
      />
      <SelectInput
        source="machineType"
        choices={[
          { id: "vacuumFiller", name: "vacuumFiller" },
          { id: "volumetricFiller", name: "volumetricFiller" },
          { id: "capper", name: "capper" },
          { id: "labeler", name: "labeler" },
          { id: "complementary", name: "complementary" },
          { id: "customSolutions", name: "customSolutions" },
          { id: "NA", name: "NA" },
        ]}
      />
      <SelectInput
        source="bottleType"
        choices={[
          { id: "burgundy", name: "burgundy" },
          { id: "bordeaux", name: "bordeaux" },
          { id: "renana", name: "renana" },
          { id: "NA", name: "NA" },
        ]}
      />
      <SelectInput
        source="shape"
        choices={[
          { id: "round", name: "round" },
          { id: "square", name: "square" },
          { id: "elliptical", name: "elliptical" },
          { id: "rectangular", name: "rectangular" },
          { id: "NA", name: "NA" },
        ]}
      />
      <SelectInput
        source="material"
        choices={[
          { id: "glass", name: "glass" },
          { id: "metal", name: "metal" },
          { id: "laminated", name: "laminated" },
          { id: "plastic", name: "plastic" },
          { id: "aluminum", name: "aluminum" },
          { id: "tin", name: "tin" },
          { id: "wooden", name: "wooden" },
          { id: "NA", name: "NA" },
        ]}
      />
      <NumberInput source="volume" step="0.01" />
      <NumberInput source="weight" step="0.01" />
      <SelectArrayInput
        source="colors"
        choices={[
          { id: "vn", name: "vn" },
          { id: "ve", name: "ve" },
          { id: "ag", name: "ag" },
          { id: "mb", name: "mb" },
          { id: "bn", name: "bn" },
          { id: "eb", name: "eb" },
          { id: "xb", name: "xb" },
          { id: "rb", name: "rb" },
          { id: "NA", name: "NA" },
        ]}
      />
      <SelectArrayInput
        source="neckFinish"
        choices={[
          { id: "dop", name: "dop" },
          { id: "ropp18", name: "ropp18" },
          { id: "ropp24", name: "ropp24" },
          { id: "ropp25", name: "ropp25" },
          { id: "ropp28", name: "ropp28" },
          { id: "ropp315", name: "ropp315" },
          { id: "ropp35", name: "ropp35" },
          { id: "bvs30", name: "bvs30" },
          { id: "corkFA", name: "corkFA" },
          { id: "corkFP", name: "corkFP" },
          { id: "vinolok", name: "vinolok" },
          { id: "stopper", name: "stopper" },
          { id: "gpi", name: "gpi" },
          { id: "gcmi", name: "gcmi" },
          { id: "twistOff", name: "twistOff" },
          { id: "grinder", name: "grinder" },
          { id: "rical29", name: "rical29" },
          { id: "rical32", name: "rical32" },
          { id: "tm", name: "tm" },
          { id: "crown26", name: "crown26" },
          { id: "crown29", name: "crown29" },
          { id: "fc29", name: "fc29" },
          { id: "tap", name: "tap" },
          { id: "spray", name: "spray" },
          { id: "NA", name: "NA" },
        ]}
      />
      <SelectInput
        source="security"
        choices={[
          { id: "dop", name: "dop" },
          { id: "dopTE", name: "dopTE" },
          { id: "ringTE", name: "ringTE" },
          { id: "none", name: "none" },
          { id: "NA", name: "NA" },
        ]}
      />
      <NumberInput source="innerNeckDiameter" step="0.01" />
      <NumberInput source="outerNeckDiameter" step="0.01" />
      <NumberInput source="diameter" step="0.01" />
      <NumberInput source="height" step="0.01" />
      <NumberInput source="palletHAmount" step="1" />
      <NumberInput source="palletLAmount" step="1" />
      <DateInput disabled source="date" />
      <BooleanInput source="isActive" />
    </SimpleForm>
  </Edit>
);

export const ProductCreate = (props) => (
  <Create title="Add Product" {...props}>
    <SimpleForm>
      <ImageInput source="image" validate={[required()]}>
        <ImageField source="src" />
      </ImageInput>
      <TextInput
        source="name"
        validate={[required()]}
        inputProps={{ maxLength: 100 }}
      />
      <TextInput source="nameTR" inputProps={{ maxLength: 100 }} />
      <TextInput source="description" inputProps={{ maxLength: 1500 }} />
      <TextInput source="descriptionTR" inputProps={{ maxLength: 1500 }} />
      <SelectInput
        source="sector"
        choices={[
          { id: "oliveOil", name: "oliveOil" },
          { id: "wine", name: "wine" },
          { id: "sparkling", name: "sparkling" },
          { id: "alcohol", name: "alcohol" },
          { id: "various", name: "various" },
          { id: "cosmetics", name: "cosmetics" },
        ]}
        validate={[required()]}
      />
      <SelectInput
        source="cosmeticsSector"
        choices={[
          { id: "colorCosmetics", name: "colorCosmetics" },
          { id: "personalCare", name: "personalCare" },
          { id: "perfumery", name: "perfumery" },
          { id: "airRefreshener", name: "airRefreshener" },
        ]}
      />
      <SelectInput
        source="cosmeticsType"
        choices={[
          { id: "mascara", name: "mascara" },
          { id: "eyebrowMascara", name: "eyebrowMascara" },
          { id: "lipGloss", name: "lipGloss" },
          { id: "compactsPallets", name: "compactsPallets" },
          { id: "eyeliner", name: "eyeliner" },
          { id: "lipstick", name: "lipstick" },
          { id: "lipBalm", name: "lipBalm" },
          { id: "faceStick", name: "faceStick" },
          { id: "nailPolish", name: "nailPolish" },
        ]}
      />
      <SelectInput
        source="type"
        choices={[
          { id: "bottle", name: "bottle" },
          { id: "jar", name: "jar" },
          { id: "cap", name: "cap" },
          { id: "capsule", name: "capsule" },
          { id: "machine", name: "machine" },
          { id: "outer", name: "outer" },

          { id: "brush", name: "brush" },
          { id: "applicator", name: "applicator" },
          { id: "dropper", name: "dropper" },
          { id: "tube", name: "tube" },
          { id: "deoStick", name: "deoStick" },
          { id: "deoRollOn", name: "deoRollOn" },
          { id: "pump", name: "pump" },
          { id: "airlessPackaging", name: "airlessPackaging" },
          { id: "mistSprayer", name: "mistSprayer" },
          { id: "sticks", name: "sticks" },
        ]}
        validate={[required()]}
      />
      <SelectInput
        source="machineType"
        choices={[
          { id: "vacuumFiller", name: "vacuumFiller" },
          { id: "volumetricFiller", name: "volumetricFiller" },
          { id: "capper", name: "capper" },
          { id: "labeler", name: "labeler" },
          { id: "complementary", name: "complementary" },
          { id: "customSolutions", name: "customSolutions" },
          { id: "NA", name: "NA" },
        ]}
      />
      <SelectInput
        source="bottleType"
        choices={[
          { id: "burgundy", name: "burgundy" },
          { id: "bordeaux", name: "bordeaux" },
          { id: "renana", name: "renana" },
          { id: "NA", name: "NA" },
        ]}
      />
      <SelectInput
        source="shape"
        choices={[
          { id: "round", name: "round" },
          { id: "square", name: "square" },
          { id: "elliptical", name: "elliptical" },
          { id: "rectangular", name: "rectangular" },
          { id: "NA", name: "NA" },
        ]}
      />
      <SelectInput
        source="material"
        choices={[
          { id: "glass", name: "glass" },
          { id: "metal", name: "metal" },
          { id: "laminated", name: "laminated" },
          { id: "plastic", name: "plastic" },
          { id: "aluminum", name: "aluminum" },
          { id: "tin", name: "tin" },
          { id: "wooden", name: "wooden" },
          { id: "NA", name: "NA" },
        ]}
      />
      <NumberInput source="volume" step="0.01" />
      <NumberInput source="weight" step="0.01" />
      <SelectArrayInput
        source="colors"
        choices={[
          { id: "vn", name: "vn" },
          { id: "ve", name: "ve" },
          { id: "ag", name: "ag" },
          { id: "mb", name: "mb" },
          { id: "bn", name: "bn" },
          { id: "eb", name: "eb" },
          { id: "xb", name: "xb" },
          { id: "rb", name: "rb" },
          { id: "NA", name: "NA" },
        ]}
      />
      <SelectArrayInput
        source="neckFinish"
        choices={[
          { id: "dop", name: "dop" },
          { id: "ropp18", name: "ropp18" },
          { id: "ropp24", name: "ropp24" },
          { id: "ropp25", name: "ropp25" },
          { id: "ropp28", name: "ropp28" },
          { id: "ropp315", name: "ropp315" },
          { id: "ropp35", name: "ropp35" },
          { id: "bvs30", name: "bvs30" },
          { id: "corkFA", name: "corkFA" },
          { id: "corkFP", name: "corkFP" },
          { id: "vinolok", name: "vinolok" },
          { id: "stopper", name: "stopper" },
          { id: "gpi", name: "gpi" },
          { id: "gcmi", name: "gcmi" },
          { id: "twistOff", name: "twistOff" },
          { id: "grinder", name: "grinder" },
          { id: "rical29", name: "rical29" },
          { id: "rical32", name: "rical32" },
          { id: "tm", name: "tm" },
          { id: "crown26", name: "crown26" },
          { id: "crown29", name: "crown29" },
          { id: "fc29", name: "fc29" },
          { id: "tap", name: "tap" },
          { id: "spray", name: "spray" },
          { id: "NA", name: "NA" },
        ]}
      />
      <SelectInput
        source="security"
        choices={[
          { id: "dop", name: "dop" },
          { id: "dopTE", name: "dopTE" },
          { id: "ringTE", name: "ringTE" },
          { id: "none", name: "none" },
          { id: "NA", name: "NA" },
        ]}
      />
      <NumberInput source="innerNeckDiameter" step="0.01" />
      <NumberInput source="outerNeckDiameter" step="0.01" />
      <NumberInput source="diameter" step="0.01" />
      <NumberInput source="height" step="0.01" />
      <NumberInput source="palletHAmount" step="1" />
      <NumberInput source="palletLAmount" step="1" />
    </SimpleForm>
  </Create>
);

export const ProductShow = (props) => (
  <Show title={<ProductTitle />} {...props}>
    <SimpleShowLayout>
      <ImageField source="image" />
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="nameTR" />
      <TextField source="description" />
      <TextField source="descriptionTR" />
      <TextField source="sector" />
      <TextField source="cosmeticsSector" />
      <TextField source="cosmeticsType" />
      <TextField source="type" />
      <TextField source="machineType" />
      <TextField source="shape" />
      <TextField source="material" />
      <TextField source="volume" />
      <TextField source="weight" />
      <ArrayField source="colors">
        <SingleFieldList>
          <StringToLabelObject>
            <ChipField source="label" />
          </StringToLabelObject>
        </SingleFieldList>
      </ArrayField>
      <ArrayField source="neckFinish">
        <SingleFieldList>
          <StringToLabelObject>
            <ChipField source="label" />
          </StringToLabelObject>
        </SingleFieldList>
      </ArrayField>
      <TextField source="security" />
      <TextField source="innerNeckDiameter" />
      <TextField source="outerNeckDiameter" />
      <TextField source="diameter" />
      <TextField source="height" />
      <TextField source="palletHAmount" />
      <TextField source="palletLAmount" />
      <NumberField source="allVolumes" />
      <DateField source="date" />
      <BooleanField source="isActive" />
    </SimpleShowLayout>
  </Show>
);
